export const ALGOLIA_ITEMS_LIMIT = 10000;
